import axios from '@/lib/axios';
import { TerminateRequestParams } from '../types';

const confirmTerminate = (data: TerminateRequestParams, custCode: string | undefined) => {
  return axios.post(`/facility/facility_agreements/terminate_cancels/${custCode}/terminate_confirm`, data);
}

export default confirmTerminate;